import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../config/supabase'
import { ArticleCategory } from '../../types'

export const SITE_URL = 'https://find-bedemand.dk'

export const articleUrl = (slug: string) => `${SITE_URL}/${slug}/`

// Same pattern as the database check constraint on articles.slug
export const SLUG_PATTERN = /^[a-z0-9-]+$/

// Danish transliteration like the database slugify(): æ -> ae, ø -> oe, å -> aa
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/æ/g, 'ae')
    .replace(/ø/g, 'oe')
    .replace(/å/g, 'aa')
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    // é -> e, ñ -> n osv.
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function useArticleCategories(enabled: boolean) {
  return useQuery({
    queryKey: ['article_categories'],
    enabled,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('article_categories')
        .select('*')
        .order('position')
        .order('name')

      if (error) throw error
      return (data || []) as ArticleCategory[]
    },
  })
}
